<template>
  <div class="c-overview-summary component">
    <span>Szanowny kliencie,</span>
    <br />
    <span class="text--bigger">{{ lead.first_name }} {{ lead.last_name }}</span>
    <br />
    <span>{{ lead.email }}</span>
    <br />
    <span class="text-upper text--huge mt--2">Bardzo dziękujemy za Twoje zlecenie!</span>
    <br />
    <span>Wizyta pojazdu</span>
    <span class="text--bigger">
      {{ lead.registration_number }} {{ lead.model_id }}
      <span>{{ lead.brand_val }}</span></span>
    <span>została zgłoszona.</span>
    <br />
    <span>Zaplanowane przyjęcie w dniu</span>
    <span class="text--bigger">
      {{
        getDetepickerConfig.formatLocale.weekdaysShort[getDayofWeek(lead.date)]
      }}, {{ lead.date }}
    </span>
    <span> o godz. </span>
    <span class="text--bigger">{{ lead.hour }}</span>

    <div class="mb--1 mt--1" v-if="getSelectedDealer">
      <img src="@/assets/localizations.jpg" alt="Localization" class="c-overview-summary__icon" />
      <h3 class="c-overview-summary__dealerName">
        {{ getSelectedDealer.name }}
      </h3>
    </div>
    <span>Doradca serwisowy: {{ getAvailableTerms[lead.term_key].user_name }}</span>
    <span v-html="getAvailableTerms[lead.term_key].user_phone
        ? '<br>tel:' + getAvailableTerms[lead.term_key].user_phone
        : ''
      "></span>
    <span v-html="getAvailableTerms[lead.term_key].user_email
        ? '<br>' + getAvailableTerms[lead.term_key].user_email + '<br>'
        : ''
      "></span>
    <br />

    <div class="mb--5 mt--1" v-if="lead.replacement_car_id != null">
      Mobilność:
      {{
        [...getReplacementCars]
          .filter((e) => (e.id == lead.replacement_car_id ? e.model : false))
          .map((e) => e.brand + " " + e.model)[0]
      }}
    </div>

    <span class="mt--2">
      <p>Szanowni Państwo,</p>
      <p>
        Pragniemy poinformować iż w trosce o komfort naszych Klientów zapewniamy
        możliwość bezkontaktowego pozostawienia oraz odbioru pojazdu.
        <br />
        W tym celu przygotowaliśmy dwa kluczykomaty: w wejściu głównym oraz
        bezpośrednio w strefie serwisu.
      </p>
    </span>

    <span class="mt--2">Usługi do wykonania:</span>
    <div class="flex-col--5 mt--1 mb--2">
      <p>{{ lead.services_name.join(', ') }}</p>
    </div>
    <span class="mt--1">Komentarz</span>
    <div class="component">
      {{ lead.comment_val }}
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import lead from "../../mixins/lead.js";
export default {
  mixins: [lead],
  computed: {
    ...mapGetters({
      getDealers: "definitions/getDealers",
      getAddmissionTerms: "definitions/getAddmissionTerms",
      getDetepickerConfig: "definitions/getDetepickerConfig",
      getReplacementCars: "definitions/getReplacementCars",
      getServices: "definitions/getServices",
      getAvailableTerms: "definitions/getAvailableTerms",
    }),
    getSelectedDealer() {
      return this.getDealers.find((e) => e.id == this.lead.dealer_id);
    },
  },
};
</script>
<style lang="scss">
.c-overview-summary {
  font-size: 1.25rem;

  &__icon {
    width: 24px;
    float: left;
    margin-right: 0.25rem;
  }

  &__dealerName {}

  &__service {
    font-size: 1rem;
  }
}
</style>